jQuery( document ).ready( function ( $ ) {
	if( $(".block-rows-with-clicks" ).length ) {

		let list = document.querySelectorAll('.rows-with-clicks-mobile__item');

		if (list.length) {
			list[0].classList.add('active');
			document.addEventListener('click', function (e) {

				const solutionsElement = e.target.closest('.rows-with-clicks-mobile__item');

				if (!solutionsElement) return true;

				const isClosed = !solutionsElement.closest('.rows-with-clicks-mobile__item').classList.contains('active');
				const solutionsElements = document.querySelectorAll('.rows-with-clicks-mobile__item');

				for (let i = 0, n = solutionsElements.length; i < n; i++) {
					solutionsElements[i].classList.remove('active');
				}

				if (isClosed) solutionsElement.closest('.rows-with-clicks-mobile__item').classList.add('active');
			});
		}
	
	}
})
